import { pipe } from '../../utils.js';

const computeCoordinates = ({ height, width, columns }) => index => {
    const floor = Math.floor(index / columns);
    const remaining = index - columns  * floor;
    return !remaining
        ? { y: height * floor, x: 0 }
        : { y: floor * height, x: remaining * width }
};

const getIndex = xs => x => xs.indexOf(x);

export const getCoordinates = ({ items, height, width, columns }) => pipe(
    getIndex(items), 
    computeCoordinates({ height, width, columns })
);